<template>
  <div :class="[isModuleOpen ? 'module-open' : 'module-close']">
    <div v-if="isModuleOpen">
      <slot name="main" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

export default defineComponent({
  name: 'ModuleWrapper',
  props: {
    moduleId: { type: String, required: true }
  },
  activated() {
    this.$emit('initializeData');
  },
  computed: {
    ...mapState('customDomain', ['currentModuleId']),
    isModuleOpen(): boolean {
      return this.currentModuleId === this.moduleId;
    }
  },
  watch: {
    isModuleOpen(isModuleOpenNew, isModuleOpenOld) {
      if (!isModuleOpenOld && isModuleOpenNew) {
        this.$emit('initializeData');
      }
    }
  }
});
</script>
